import React from "react";
import {
    Navbar,
    MobileNav,
    Typography,
    Button,
    IconButton,

} from "@material-tailwind/react";
import {Link} from "react-router-dom";

export function LandingMenu() {
    const [openNav, setOpenNav] = React.useState(false);

    React.useEffect(() => {
        window.addEventListener(
            "resize",
            () => window.innerWidth >= 960 && setOpenNav(false),
        );
    }, []);

    const navList = (
        <ul className="mt-2 mb-4 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
            <Link to="/">
                <Typography
                    as="li"
                    variant="small"
                    color="blue-gray"
                    className="p-1 font-normal"
                >
                    <span className="flex items-center">
                        Početna
                    </span>
                </Typography>
            </Link>
            <Link to="/o_nama">
            <Typography
                as="li"
                variant="small"
                color="blue-gray"
                className="p-1 font-normal"
            >
                <span className="flex items-center">
                    O nama
                </span>
            </Typography>
            </Link>
            <Link to="/saveti">
                <Typography
                    as="li"
                    variant="small"
                    color="blue-gray"
                    className="p-1 font-normal"
                >
                    <span className="flex items-center">
                        Saveti
                    </span>
                </Typography>
            </Link>
            <Link to="/kontakt">
                <Typography
                    as="li"
                    variant="small"
                    color="blue-gray"
                    className="p-1 font-normal"
                >
                    <span className="flex items-center">
                        Kontakt
                    </span>
                </Typography>
            </Link>
        </ul>
    );

    return (
        <div className="w-full lg:w-[80%] mx-auto max-h-[768px]">
            <Navbar className="sticky top-0 z-10 h-max max-w-full px-4 py-3 lg:px-8 lg:py-4 rounded-lg shadow-lg backdrop-blur-md bg-white">
                <div className="flex items-center justify-between text-blue-gray-900">
                    <Link to="/">
                        <div className="flex items-center">
                            <span className="cursor-pointer py-1.5">
                                <img
                                    src="/transparent logo solo.png"
                                    alt="Smart Service System Logo"
                                    className="h-6 w-auto"
                                />
                            </span>
                            <Typography
                                className="cursor-pointer py-2 font-semibold text-gray-900 text-lg tracking-tight leading-tight rounded-full px-6"
                            >
                                Smart Service System
                            </Typography>
                        </div>
                    </Link>
                    <div className="flex items-center gap-4">
                        <div className="mr-4 hidden lg:block">{navList}</div>
                        <div className="flex items-center gap-x-1">
                            <Link to="/login">
                                <Button
                                    variant="text"
                                    size="sm"
                                    className="hidden lg:inline-block hover:bg-gray-100 rounded-full"
                                >
                                    <span className="text-gray-900">Prijavite se</span>
                                </Button>
                            </Link>
                            <Link to="/login?tab=register">
                                <Button
                                    size="sm"
                                    className="hidden lg:inline-block bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:from-blue-400 hover:via-blue-500 hover:to-blue-600 text-white rounded-full"
                                >
                                    <span>Registracija</span>
                                </Button>
                            </Link>
                        </div>
                        <IconButton
                            variant="text"
                            className="ml-auto h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
                            ripple={false}
                            onClick={() => setOpenNav(!openNav)}
                        >
                            {openNav ? (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    className="h-6 w-6"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            ) : (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M4 6h16M4 12h16M4 18h16"
                                    />
                                </svg>
                            )}
                        </IconButton>
                    </div>
                </div>
                <MobileNav open={openNav}>
                    {navList}
                    <div className="flex items-center gap-x-1">
                        <Link to="/login">
                            <Button fullWidth variant="text" size="sm" className="rounded-full">
                                <span className="text-gray-900">Prijavite se</span>
                            </Button>
                        </Link>
                        <Link to="/login?tab=register">
                            <Button fullWidth variant="gradient" size="sm" className=" bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:from-blue-400 hover:via-blue-500 hover:to-blue-600 text-white rounded-full">
                                <span className="text-white">Registracija</span>
                            </Button>
                        </Link>
                    </div>
                </MobileNav>
            </Navbar>
        </div>
    );
}